import { useContext, useMemo } from "react"

import { useGeoServerFeaturesList } from "@l2r-front/l2r-geodata"

import { NetworksStateContext } from "../contexts/NetworksContext/NetworksContext.context"

import { networksQueryKeys } from "./queryKeys"

export const useRoadSubNetworks = (road) => {
    const context = useContext(NetworksStateContext)

    if (context === undefined) {
        throw new Error("useRoadSubNetworks must be used within an NetworksContextProvider")
    }

    const { data: roadSegments } = useGeoServerFeaturesList(
        networksQueryKeys.list({ road }),
        {
            layer: context.selectedNetwork?.referential?.layerSection,
            linear_location_road: road,
        },
        {
            enabled: !!road && !!context.selectedNetwork?.referential,
        })

    return useMemo(() => {
        const roadSubNetworks = (roadSegments || []).reduce((acc, curr) => {
            if (curr.sub_network_slugs && curr.sub_network_slugs.length) {
                curr.sub_network_slugs.forEach(sn => {
                    acc.add(sn)
                })
            }
            return acc
        }, new Set())

        return Array.from(roadSubNetworks)
    }, [roadSegments])
}